<template>
    <div>
        <InfoIcon v-if="showInfoIcon" v-tooltip="{ content: $t('CourseListFilter.here_filter_bla_bla'), html: true }"/>
        <TotemTag
            v-for="{label, filterKey, value, count, translatedLabel} in tags" :name="translatedLabel"
            :count="count"
            :key="filterKey+'-'+value"
            @handleClick="removeFilter(value, filterKey)"
            :class="`${$totemLang}-${filterKey}`"
        />
        <DesktopClearFilters />
    </div>
</template>

<script>
    import InfoIcon from 'components/searchable-listing/filters-elements/InfoIcon'
    import DesktopClearFilters from 'components/searchable-listing/filters-elements/DesktopClearFilters'

    export default {
        name: 'Tags',
        components: {
            InfoIcon,
            DesktopClearFilters
        },
        props: {
            showInfoIcon: {
                type: Boolean,
                required: true,
            },
            tags: {
                type: Array,
                required: true
            }
        },
        methods: {
            removeFilter (value, key) {
                this.$store.dispatch('Search/removeFilterValue', { key, value })
            }
        }
    }
</script>
